var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIndicatorO(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3249,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard8",
    transform: "matrix(1,0,0,1,-0.0534114,-0.37236)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3249.05,
    y: 0.372,
    width: 92.733,
    height: 92.733,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3249.05,
    y: 0.372,
    width: 92.733,
    height: 92.733
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,251.364,1119.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3044.11,-1119.14C3069.7,-1119.14 3090.47,-1098.36 3090.47,-1072.77C3090.47,-1047.18 3069.7,-1026.4 3044.11,-1026.4C3018.52,-1026.4 2997.74,-1047.18 2997.74,-1072.77C2997.74,-1098.36 3018.52,-1119.14 3044.11,-1119.14ZM3044.11,-1100.39C3059.35,-1100.39 3071.72,-1088.01 3071.72,-1072.77C3071.72,-1057.53 3059.35,-1045.15 3044.11,-1045.15C3028.87,-1045.15 3016.49,-1057.53 3016.49,-1072.77C3016.49,-1088.01 3028.87,-1100.39 3044.11,-1100.39Z",
    style: {
      fill: "rgb(107,252,178)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIndicatorO);
export default __webpack_public_path__ + "static/media/team_indicator_o.829a9f359601def42f8ecdc78db57a24.svg";
export { ForwardRef as ReactComponent };